import React from 'react';
import { Box } from '@mui/material';
import Hero from '../components/Hero';

const Home = () => {

  return (
    <Box>
      <Hero />
    </Box>
  );
};

export default Home;
